import { defaultAllSelection } from "services/constants/selections";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import * as Mui from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { Daily } from "./Daily";
import { Weekly } from "./Weekly";
import { useSelector, useDispatch } from "react-redux";
import { setShowShiftBack } from "services/Redux/TeamZone";
import { setPlanShiftScreen } from "services/Redux/TeamZone";
import { startOfMonth, endOfMonth } from "date-fns";
import moment from "moment";
import { showToast } from "services/utils/Status";
// import { useFetch } from "services/hooks/useFetch";
import sessionHandling from "services/utils/notificationUtils";
import { Monthly } from "./Monthly";
import { checkViewerPermission } from "services/utils/HelperFunction";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import dayjs from "dayjs";
import { BackArrow } from "components/CustomComponents/BackArrow";
import Groups2RoundedIcon from "@mui/icons-material/Groups2Rounded";
import PersonAddAltRoundedIcon from "@mui/icons-material/PersonAddAltRounded";
import EventBusyRoundedIcon from "@mui/icons-material/EventBusyRounded";
import AssignmentTurnedInRoundedIcon from "@mui/icons-material/AssignmentTurnedInRounded";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import { GlobalBreadcrumb } from "components/DesignSystem/sharedUiPatterns";
import { CompactHeaderSelectFilter } from "components/CustomComponents/CompactHeaderSelectFilter";
import { CustomFilter } from "components/CustomComponents/CustomFilter";
import { useExcelDownload } from "components/CustomComponents/useExcelDownload";
import { FilterProvider } from "pages/FilterContext";
import {
  designColors,
  designRadii,
  designShell,
  designTheme,
  designType,
  StatCard,
} from "services/constants/designTokens";

export const PlanShift = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { downloadCsv, downloadExcel, downloadPdf } = useExcelDownload();
  const { domain, token, userDetails, topbarCompanyId, userScreenAccess } =
    useSelector((state) => state.tokenReducer);
  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer,
  );
  const { showShiftBack } = useSelector((state) => state.teamZoneReducer);
  // const { result: departmentData } = useFetch(
  //   `${domain}get-department/?user_id=${userDetails.id}`
  // );
  const [departmentIdValue, setDepartmentIdValue] = useState(departmentId);
  const [departmentNames, setDepartmentName] = useState(departmentName);
  const [dataVisualMethod, setDataVisualMethod] = useState("Daily");
  // const [lastViewedScreens, setLastViewedScreens] = useState("Daily");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [listOfDate, setListOfDate] = useState([]);
  const [selectCurrentDate, setSelectCurrentDate] = useState(dayjs());
  const [monthlyselectedDate, setMonthlySelectedDate] = useState(new Date());
  const [formattedDate, setFormattedDate] = useState(new Date(), "yyyy-MM");
  // Starts true (not false) — Daily/Weekly/Monthly gate their table on this
  // and default to the empty-state message otherwise, and the very first
  // shift fetch only fires once fetchDepartmentData -> loadData resolves,
  // several renders after mount. Defaulting to false let that window render
  // "No Data Found" before the fetch chain had even started, flashing empty
  // state -> loader -> real rows on every fresh visit to Roster.
  const [loading, isLoading] = useState(true);
  const [fetchWeekly, setFetchWeekly] = useState(true);
  const [presentScreen, setPresentScreen] = useState(false);
  const [weeklyShiftList, setWeeklyShiftList] = useState([]);
  const [monthlyShiftList, setMonthlyShiftList] = useState([]);
  const [dailyShiftList, setDailyShiftList] = useState([]);
  const [filterChanges, setFilterChanges] = useState(false);
  // Which status-card tile is currently narrowing the table below — mirrors
  // Approve/Leave's statusCardFilter ("" = the "Total Employees" / All tile).
  const [rosterStatusFilter, setRosterStatusFilter] = useState("");
  const [masterDataForSearch, setMasterDataForSearch] = useState([]);
  const [loadData, setLoadData] = useState(false);
  const minDate = new Date(2020, 0, 1);
  const [shiftGrpError, setGrpNameError] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [departmentData, setDepartmentData] = useState([]);
  // Was a hardcoded literal (12), unlike every sibling screen (Approve/
  // index.js, LeaveSummary/index.js), which derive this from
  // userScreenAccess. If id 12 doesn't correspond to Roster's actual
  // SubModule row in this tenant, the backend's filter-preference save
  // rejects it with a 400 "Invalid submodule_id" -- resolve it the same way
  // those screens (and Roster's own checkViewerPermission call below) do,
  // by module/submodule name instead of a guessed id.
  const rosterModule = userScreenAccess?.module_details?.find(
    (mod) => mod.module_name === "Rosters",
  );
  const planShiftSubModuleId = rosterModule?.submodules?.find(
    (sub) => sub.sub_module_name === "Roster",
  )?.sub_module_id;
  const requestedView = new URLSearchParams(location.search).get("view");
  // Team Workspace Home passes the date it currently has selected (see
  // TeamZone/Home/index.js's navigateToModule) so landing here from Home's
  // "Today's Shift Coverage" card shows that same day's Daily view instead
  // of always resetting to today.
  const requestedDate = new URLSearchParams(location.search).get("date");

  useEffect(() => {
    const normalizedRequestedView = String(requestedView || "").toLowerCase();
    if (normalizedRequestedView === "monthly") {
      setDataVisualMethod("Monthly");
      dispatch(setPlanShiftScreen("Monthly"));
      localStorage.setItem("planShiftScreen", "Monthly");
      // Deliberately NOT setPresentScreen(true) here: that flag gates the
      // one-time loadData bootstrap below (line ~141), which only fires
      // "if (presentScreen !== true)". This is the initial navigation
      // itself, not a manual interaction after the screen was already
      // loaded — flipping it here permanently blocked loadData from ever
      // becoming true, which in turn blocked the shift-list API call from
      // ever firing when landing on Roster via ?view=monthly.
    } else if (normalizedRequestedView === "daily") {
      // Explicit, even though "Daily" is also this screen's own default --
      // Team Workspace Home's "Week Off Today" card now sends this
      // deliberately (see WorkforceSummaryCards.js) so its landing view stays
      // correct even if Roster's own default is ever changed.
      setDataVisualMethod("Daily");
      dispatch(setPlanShiftScreen("Daily"));
      localStorage.setItem("planShiftScreen", "Daily");
    }
  }, [dispatch, requestedView]);

  // Team Workspace Home's "Week Off Today" card lands here with
  // ?status=weeklyOff so the Weekly Off status card starts selected instead
  // of the default Total Employees (empty filter).
  const requestedStatus = new URLSearchParams(location.search).get("status");
  useEffect(() => {
    if (requestedStatus === "weeklyOff") {
      setRosterStatusFilter("weeklyOff");
    }
  }, [requestedStatus]);

  useEffect(() => {
    // No customParseFormat plugin registered in this file (unlike a few
    // others, e.g. CreateWorkAdjustment.js), so validate the shape with a
    // plain regex first rather than relying on dayjs's format-string
    // argument, which it silently ignores without that plugin.
    if (!requestedDate || !/^\d{4}-\d{2}-\d{2}$/.test(requestedDate)) return;
    const parsedDate = dayjs(requestedDate);
    if (!parsedDate.isValid()) return;
    // Seed both Daily's and Monthly's own date state — whichever view
    // requestedView (above) actually lands on reads its own, and
    // RosterPromoBanner's "Open Roster" link (Team Workspace Home) can
    // request ?view=monthly directly, so Monthly needs this too, not just
    // Daily's selectCurrentDate. monthlyselectedDate drives its
    // startOfMonth/endOfMonth fetch range further down, which in turn
    // derives formattedDate on its own — no need to set that separately.
    setSelectCurrentDate(parsedDate);
    setMonthlySelectedDate(parsedDate.toDate());
  }, [requestedDate]);

  useEffect(() => {
    if (topbarCompanyId) {
      setFetchWeekly(true);
    }
  }, [topbarCompanyId]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${userDetails.id}&company_id=${topbarCompanyId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          },
        );
        const res = await response.json();
        if (response.ok) {
          const departmentDataWithLabel = res.map((obj) => ({
            ...obj,
            label: obj.department_name,
          }));
          const allDepartment = {
            id: defaultAllSelection,
            label: "All",
            department_name: "All",
          };
          setDepartmentData([allDepartment, ...departmentDataWithLabel]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error("REQUEST_FAILED");
        }
      } catch (error) {
        console.error("[Index] operation failed:", error);
        showToast(
          "error",
          "Couldn't load shift details. Please refresh the page.",
        );
      }
    };
    fetchDepartmentData();
  }, [departmentId, domain, token, userDetails.id, topbarCompanyId]);

  useEffect(() => {
    if (presentScreen !== true && departmentData?.length !== 0 && !loadData) {
      // setDepartmentIdValue(departmentId);
      // let filterData = departmentData.filter((data) => {
      //   return data.department_name === departmentNames;
      // });
      // setDepartmentName(departmentNames);
      setLoadData(true);
    }
  }, [
    dataVisualMethod,
    departmentData,
    departmentId,
    departmentNames,
    dispatch,
    loadData,
    presentScreen,
  ]);

  const getCurrentWeek = () => moment().format("GGGG-[W]WW");

  const [selectedWeek, setSelectedWeek] = useState(getCurrentWeek);

  const getWeekDays = (startDate) => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(startDate);
      day.setDate(startDate.getDate() + i);
      days.push(day);
    }
    return days;
  };

  const handleMonthlyDateOnChange = (date) => {
    if (
      date instanceof Date &&
      !isNaN(date) &&
      date.getFullYear().toString().length === 4 &&
      date >= minDate
    ) {
      setPresentScreen(true);
      setMonthlySelectedDate(date);
    } else if (date.getFullYear().toString().length === 4 && date < minDate) {
      showToast("error", "Year must be 01/01/2020 or later");
    }
  };

  const handleWeeklyDateOnChange = (event) => {
    setSelectedWeek(event.target.value);
  };

  const handleDailyDateChange = (value) => {
    setPresentScreen(true);
    setSelectCurrentDate(dayjs(value));
    setFetchWeekly(true);
  };

  const handleMonthValueChange = (value) => {
    if (!value) return;
    const [year, month] = value.split("-");
    const parsedDate = new Date(Number(year), Number(month) - 1, 1);
    handleMonthlyDateOnChange(parsedDate);
  };
  //  && departmentIdValue !== 99999
  useEffect(() => {
    if (selectedWeek && dataVisualMethod) {
      if (dataVisualMethod === "Weekly") {
        const startDate = moment(selectedWeek).startOf("isoWeek").toDate();
        const endDate = moment(selectedWeek).endOf("isoWeek").toDate();
        const dates = getWeekDays(startDate);
        const formatDates = dates?.map((value) =>
          moment(value).format("YYYY-MM-DD"),
        );
        setListOfDate([]);
        setStartDate("");
        setEndDate("");
        setListOfDate(formatDates);
        setStartDate(moment(startDate).format("YYYY-MM-DD"));
        setEndDate(moment(endDate).format("YYYY-MM-DD"));
        if (startDate !== "" && endDate !== "") {
          setFetchWeekly(true);
        }
      } else if (
        selectCurrentDate &&
        departmentIdValue !== defaultAllSelection &&
        dataVisualMethod === "Daily"
      ) {
        if (startDate !== "") {
          setFetchWeekly(true);
        }
      } else {
        const start = startOfMonth(monthlyselectedDate);
        const end = endOfMonth(monthlyselectedDate);
        const dates = getMonthDays(start);
        const formatDates = dates?.map((value) =>
          moment(value).format("YYYY-MM-DD"),
        );
        setListOfDate([]);
        setStartDate("");
        setEndDate("");
        setListOfDate(formatDates);
        setStartDate(moment(start).format("YYYY-MM-DD"));
        setEndDate(moment(end).format("YYYY-MM-DD"));
        if (start !== "" && end !== "") {
          setFetchWeekly(true);
        }
      }
    }
  }, [
    dataVisualMethod,
    departmentIdValue,
    monthlyselectedDate,
    selectCurrentDate,
    selectedWeek,
    startDate,
  ]);

  const getMonthDays = (startDate) => {
    const days = [];
    const year = startDate.getFullYear();
    const month = startDate.getMonth();

    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0);

    let currentDate = firstDayOfMonth;

    while (currentDate <= lastDayOfMonth) {
      days.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }

    return days;
  };

  useEffect(() => {
    const formatDate = () => {
      if (monthlyselectedDate) {
        const formattedDate =
          monthlyselectedDate?.getFullYear() +
          "-" +
          ("0" + (monthlyselectedDate?.getMonth() + 1)).slice(-2);
        setFormattedDate(formattedDate);
      }
    };
    formatDate();
    if (
      formattedDate &&
      departmentIdValue !== defaultAllSelection &&
      dataVisualMethod === "Monthly"
    ) {
      setFetchWeekly(true);
    }
  }, [dataVisualMethod, departmentIdValue, formattedDate, monthlyselectedDate]);

  const updateShiftBasedOnRange = async (userId, shift_assignments) => {
    try {
      const response = await fetch(`${domain}shift_assignments/daily/?company_id=${topbarCompanyId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `token ${token}`,
        },
        body: JSON.stringify({
          shift_assignments: [
            {
              user: userId,
              daily_assignments: shift_assignments,
            },
          ],
        }),
      });
      let res = null;
      try {
        res = await response.json();
      } catch {
        res = null;
      }
      if (response.ok) {
        // A single hardcoded "Shift assigned." used to show for every action
        // (assign, edit, mark Week Off, or unassign back to Unassigned),
        // which read as wrong/misleading for the latter two.
        const allWeekOff = shift_assignments.every((a) => a.is_week_off);
        const allUnassigned = shift_assignments.every((a) => a.unassigned);
        const message = allWeekOff
          ? "Marked as Week Off."
          : allUnassigned
            ? "Shift unassigned."
            : "Shift assigned.";
        showToast("success", message);
        setFetchWeekly(true);
        setOpenDialog(false);
        setGrpNameError(false);
      } else if (response.status === 409) {
        sessionHandling();
      } else {
        // Surface the backend's actual reason (e.g. a date-of-joining
        // violation) instead of a blanket message that hid it.
        showToast(
          "error",
          res?.error || "Couldn't assign the shift. Please try again.",
        );
      }
    } catch (error) {
      console.error("[Index] operation failed:", error);
      showToast("error", "Couldn't assign the shift. Please try again.");
    }
  };

  useEffect(() => {
    const fetchWeeklyShiftList = async () => {
      isLoading(true);
      const formattedDate = dayjs(selectCurrentDate).format("YYYY-MM-DD");
      try {
        let url =
          dataVisualMethod === "Daily"
            ? `${domain}daily_user_shift_assignments/?department_id=${departmentIdValue}&from_date=${formattedDate}&to_date=${formattedDate}&user_id=${userDetails?.id}&company_id=${topbarCompanyId}`
            : `${domain}daily_user_shift_assignments/?department_id=${departmentIdValue}&from_date=${startDate}&to_date=${endDate}&user_id=${userDetails?.id}&company_id=${topbarCompanyId}`;
        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `token ${token}`,
          },
        });
        const res = await response.json();
        if (response.ok) {
          const rows = res?.data || [];
          setMasterDataForSearch([]);
          dataVisualMethod === "Monthly"
            ? setMonthlyShiftList([])
            : setWeeklyShiftList([]);
          dataVisualMethod === "Daily" && setDailyShiftList(res?.data);
          dataVisualMethod === "Monthly"
            ? setMonthlyShiftList(res?.data)
            : setWeeklyShiftList(res?.data);

          setMasterDataForSearch(res?.data);
          // Also seed the filtered roster rows directly from this fetch —
          // CustomFilter recomputes filteredRosterRows in its own effect a
          // render later, so without this the table briefly keeps the
          // previous view's rows (or none, on first load) right as loading
          // ends, flashing "No Matching Results" before the real rows land
          // (same fix as Approve's list screens). Only `__source` matters
          // here — Daily/Weekly/Monthly read the raw row through that, and
          // CustomFilter's effect fills in the rest (sort order, export
          // fields) a moment later.
          setFilteredRosterRows(rows.map((row) => ({ __source: row })));
          isLoading(false);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error("REQUEST_FAILED");
        }
      } catch (error) {
        console.error("[Index] operation failed:", error);
        showToast(
          "error",
          "Couldn't load shift details. Please refresh the page.",
        );
        isLoading(false);
      }
    };
    if (fetchWeekly && departmentIdValue !== "" && loadData) {
      fetchWeeklyShiftList();
      setFetchWeekly(false);
    }
  }, [
    dataVisualMethod,
    departmentIdValue,
    domain,
    endDate,
    fetchWeekly,
    loadData,
    selectCurrentDate,
    startDate,
    token,
    topbarCompanyId,
    userDetails?.id,
  ]);

  const updateDepartmentName = (event, data) => {
    if (data) {
      setDepartmentIdValue(data.id);
      setDepartmentName(data.department_name);
      setFetchWeekly(true);
    }
  };

  const activeShiftList =
    dataVisualMethod === "Daily"
      ? dailyShiftList
      : dataVisualMethod === "Monthly"
        ? monthlyShiftList
        : weeklyShiftList;

  // Classifies one employee row into the same status buckets the summary
  // cards below count — extracted so the status-card click filter can reuse
  // exactly the same rules the counts are based on. Also fixes the no-shifts
  // case to return the same {hasAssigned, ...} shape as every other branch
  // (it used to return the bare string "unassigned", which made
  // `flags.hasUnassigned` undefined and silently dropped shiftless
  // employees from the "Unassigned" count).
  const statusForEmployee = useCallback(
    (employee) => {
      const shifts =
        dataVisualMethod === "Daily"
          ? employee?.shift_name
            ? [employee]
            : employee?.shifts || []
          : employee?.shifts || [];

      if (!shifts.length) {
        return {
          hasAssigned: false,
          hasWeekOff: false,
          hasLeave: false,
          hasUnassigned: true,
          hasNotJoined: false,
          assignedDayCount: 0,
          weekOffDayCount: 0,
          notJoinedDayCount: 0,
        };
      }

      const names = shifts.map((shift) => shift?.shift_name || "");
      const lowerNames = names.map((name) => name.toLowerCase());
      const isAssignedShift = (name) =>
        name &&
        name !== "unassigned" &&
        name !== "not joined" &&
        name !== "weekoff" &&
        name !== "leave" &&
        name !== "holiday";

      const assignedDayCount = lowerNames.filter(isAssignedShift).length;
      const hasAssigned = assignedDayCount > 0;
      const hasWeekOff = lowerNames.some((name) => name === "weekoff");
      const hasLeave = lowerNames.some((name) => name === "leave");
      // Only days literally marked "Unassigned" count. Empty/"not joined"
      // days belong to the Not Joined bucket, otherwise the Unassigned card
      // and filter also list employees who are simply Not Joined.
      const hasUnassigned = lowerNames.some((name) => name === "unassigned");
      // The backend sends a bare `null` shift_name (-> "" here) specifically
      // for days before the employee's date of joining, distinct from the
      // literal "Unassigned" it sends for a day they just have no shift on.
      // Both used to fold into the same `hasUnassigned` bucket with no way
      // to see the "Not Joined" count on its own -- kept `hasUnassigned` as
      // the same combined bucket (existing consumers, e.g. the Unassigned
      // card/filter, are unaffected) and added this alongside it.
      const hasNotJoined = lowerNames.some(
        (name) => !name || name === "not joined",
      );
      // Distinct from hasWeekOff: on Weekly/Monthly, an employee has several
      // days in range, so "did they have any week off" collapses every
      // employee with >=1 week-off day to the same true/false — in a full
      // month that's nearly everyone, inflating the "Weekly Off" stat card
      // to ~= Total Employees. The card wants the actual day count.
      const weekOffDayCount = lowerNames.filter(
        (name) => name === "weekoff",
      ).length;
      const notJoinedDayCount = lowerNames.filter(
        (name) => !name || name === "not joined",
      ).length;

      return {
        hasAssigned,
        hasWeekOff,
        hasLeave,
        hasUnassigned,
        hasNotJoined,
        assignedDayCount,
        weekOffDayCount,
        notJoinedDayCount,
      };
    },
    [dataVisualMethod],
  );

  const normalizedPeriodLabel = useMemo(() => {
    if (dataVisualMethod === "Daily") {
      return dayjs(selectCurrentDate).format("DD MMM YYYY");
    }
    if (dataVisualMethod === "Weekly" && listOfDate?.length) {
      return `${moment(listOfDate[0]).format("DD MMM")} - ${moment(
        listOfDate[listOfDate.length - 1],
      ).format("DD MMM YYYY")}`;
    }
    if (dataVisualMethod === "Monthly" && listOfDate?.length) {
      return `${moment(listOfDate[0]).format("DD MMM")} - ${moment(
        listOfDate[listOfDate.length - 1],
      ).format("DD MMM YYYY")}`;
    }
    return "";
  }, [dataVisualMethod, listOfDate, selectCurrentDate]);

  const formatShiftCellText = useCallback((shift) => {
    const shiftName = shift?.shift_name || "Not Joined";
    const hideTime =
      shift?.shift_name === null ||
      shift?.shift_name === "Weekoff" ||
      !shift?.shift_start_time ||
      !shift?.shift_end_time;

    if (hideTime) {
      return shiftName;
    }

    const startTime = moment(shift?.shift_start_time, [
      "HH:mm:ss",
      "HH:mm:SS",
    ]).format("h:mm a");
    const endTime = moment(shift?.shift_end_time, [
      "HH:mm:ss",
      "HH:mm:SS",
    ]).format("h:mm a");

    return `${shiftName} - ${startTime} to ${endTime}`;
  }, []);

  const shiftDateColumns = useMemo(
    () =>
      (listOfDate || []).map((value, index) => {
        const normalizedDate = moment(value, "YYYY-MM-DD");
        return {
          key: normalizedDate.isValid()
            ? `day_${normalizedDate.format("YYYY_MM_DD")}`
            : `day_${index + 1}`,
          value,
          label:
            dataVisualMethod === "Weekly"
              ? `${normalizedDate.format("DD")} ${normalizedDate.format(
                  "ddd, MMM",
                )}`
              : `${normalizedDate.format("DD")} ${normalizedDate.format(
                  "ddd",
                )}`,
        };
      }),
    [dataVisualMethod, listOfDate],
  );

  const rosterFilterHeaders = useMemo(() => {
    const baseHeaders = [
      {
        name: dataVisualMethod === "Daily" ? "Name" : "Employee Name",
        key: "user_name",
        type: "string",
        icon: <PersonOutlineIcon fontSize="small" />,
      },
    ];

    if (dataVisualMethod === "Daily") {
      return [
        ...baseHeaders,
        {
          name: "Shift & Time",
          key: "shift_time",
          type: "autocomplete",
          icon: <AssignmentTurnedInRoundedIcon fontSize="small" />,
        },
      ];
    }

    // Weekly/Monthly: Employee Name only — the per-date shift filters were
    // removed on request (the date columns stay in the table and exports).
    return baseHeaders;
  }, [dataVisualMethod]);

  // Sorting by one day's composite "Shift - 9:00 am to 6:00 pm" text (every
  // other column `rosterFilterHeaders` exposes) reads as broken -- it's not
  // a meaningful roster ordering. Restrict Sort to Employee Name and let
  // Filter keep the full column set, instead of both dropdowns silently
  // resolving to the same `rosterFilterHeaders` list.
  const rosterSortHeaders = useMemo(
    () => rosterFilterHeaders.slice(0, 1),
    [rosterFilterHeaders],
  );

  const canManageShift = checkViewerPermission(
    userScreenAccess?.module_details,
    "Rosters",
    "Roster",
  );

  const buildRosterExportRow = useCallback(
    (row, index) => {
      const shifts = row?.shifts?.length
        ? row.shifts
        : row?.shift_name
          ? [row]
          : [];

      const exportRow = {
        id: row?.user_id || index,
        user_name: row?.user_name || "",
        department_name: row?.department_name || departmentNames || "",
      };

      if (dataVisualMethod === "Daily") {
        exportRow.shift_time = formatShiftCellText(shifts[0] || row);
        return exportRow;
      }

      const shiftsByDate = new Map(
        shifts.map((shift) => {
          const normalizedDate = moment(
            shift?.date,
            ["DD-MM-YYYY", "YYYY-MM-DD"],
            true,
          );
          return [
            normalizedDate.isValid() ? normalizedDate.format("YYYY-MM-DD") : "",
            shift,
          ];
        }),
      );

      shiftDateColumns.forEach((column, columnIndex) => {
        const matchedShift =
          shiftsByDate.get(column.value) || shifts[columnIndex] || null;
        exportRow[column.key] = formatShiftCellText(matchedShift);
      });

      return exportRow;
    },
    [dataVisualMethod, departmentNames, formatShiftCellText, shiftDateColumns],
  );

  const filterInputRows = useMemo(() => {
    return [...(activeShiftList || [])]
      .sort((firstRow, secondRow) =>
        (firstRow?.user_name || "").localeCompare(
          secondRow?.user_name || "",
          undefined,
          { numeric: true },
        ),
      )
      .map((row, index) => ({
        ...buildRosterExportRow(row, index),
        __source: row,
      }));
  }, [activeShiftList, buildRosterExportRow]);

  const [filteredRosterRows, setFilteredRosterRows] = useState(filterInputRows);

  useEffect(() => {
    setFilterChanges(true);
  }, [filterInputRows]);

  const handleFilteredRosterChange = useCallback(
    (rows) => {
      setFilteredRosterRows(rows);
      setFilterChanges(true);
    },
    [setFilterChanges],
  );

  // Layered on top of whatever CustomFilter's own search/sort/filter
  // produced, driven by the status cards above — same pattern as Approve/
  // Leave's visibleLeaveData.
  const visibleRosterRows = useMemo(() => {
    const statusFilteredRows = !rosterStatusFilter
      ? filteredRosterRows
      : filteredRosterRows.filter((row) => {
          const flags = statusForEmployee(row.__source);
          if (rosterStatusFilter === "assigned") return flags.hasAssigned;
          if (rosterStatusFilter === "weeklyOff") return flags.hasWeekOff;
          if (rosterStatusFilter === "onLeave") return flags.hasLeave;
          if (rosterStatusFilter === "unassigned") {
            return flags.hasUnassigned && !flags.hasAssigned;
          }
          if (rosterStatusFilter === "notJoined") return flags.hasNotJoined;
          return true;
        });

    return statusFilteredRows;
  }, [filteredRosterRows, rosterStatusFilter, statusForEmployee]);

  const handleRosterStatusCardClick = useCallback((key) => {
    setRosterStatusFilter((prev) => (prev === key ? "" : key));
    setFilterChanges(true);
  }, []);

  const visibleShiftList = useMemo(
    () => visibleRosterRows.map((row) => row.__source),
    [visibleRosterRows],
  );

  const renderComponent = () => {
    switch (dataVisualMethod) {
      case "Daily":
        return (
          <Daily
            dailyShiftList={visibleShiftList}
            loading={loading}
            filterChanges={filterChanges}
            setFilterChanges={setFilterChanges}
            updateDailyShift={updateShiftBasedOnRange}
            selectCurrentDate={selectCurrentDate}
            shiftGrpError={shiftGrpError}
            setGrpNameError={setGrpNameError}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            departmentIdValue={departmentIdValue}
            setDepartmentIdValue={setDepartmentIdValue}
            setFetchWeekly={setFetchWeekly}
            departmentNames={departmentNames}
            masterDataForSearch={masterDataForSearch}
          />
        );
      case "Monthly":
        return (
          <Monthly
            loading={loading}
            isLoading={isLoading}
            monthlyShiftList={visibleShiftList}
            filterChanges={filterChanges}
            setFilterChanges={setFilterChanges}
            listOfDate={listOfDate}
            updateMonthlyShift={updateShiftBasedOnRange}
            shiftGrpError={shiftGrpError}
            setGrpNameError={setGrpNameError}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            departmentIdValue={departmentIdValue}
            departmentNames={departmentNames}
            masterDataForSearch={masterDataForSearch}
          />
        );
      case "Weekly":
        return (
          <Weekly
            loading={loading}
            weeklyShiftList={visibleShiftList}
            filterChanges={filterChanges}
            setFilterChanges={setFilterChanges}
            listOfDate={listOfDate}
            updateWeeklyShift={updateShiftBasedOnRange}
            setFetchWeekly={setFetchWeekly}
            shiftGrpError={shiftGrpError}
            setGrpNameError={setGrpNameError}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            departmentIdValue={departmentIdValue}
            departmentNames={departmentNames}
            masterDataForSearch={masterDataForSearch}
          />
        );
      // case "MoveShiftGroup":
      //   return (
      //     <MoveShiftGroup
      //       lastViewedScreens={lastViewedScreens}
      //       setDataVisualMethod={setDataVisualMethod}
      //       reCallApi={setLoadData}
      //     />
      //   );
      default:
        break;
    }
  };

  const switchView = (nextView) => {
    isLoading(true);
    setPresentScreen(true);
    if (nextView === "Daily") {
      setFetchWeekly(true);
      setSelectedWeek(getCurrentWeek);
    }
    if (nextView === "Weekly") {
      setSelectedWeek(getCurrentWeek);
    }
    setDataVisualMethod(nextView);
    dispatch(setPlanShiftScreen(nextView));
    localStorage.setItem("planShiftScreen", nextView);
  };

  const buttons = [
    {
      value: "Daily",
      label: "Daily",
      onClick: () => switchView("Daily"),
    },
    {
      value: "Weekly",
      label: "Weekly",
      onClick: () => switchView("Weekly"),
    },
    {
      value: "Monthly",
      label: "Monthly",
      onClick: () => switchView("Monthly"),
    },
  ];

  // Was computed from `activeShiftList` (the raw, unfiltered fetch), while
  // the table below renders `visibleShiftList` (post search/saved-filter/
  // sort) -- the two silently diverged the moment any filter was active
  // (including one FilterProvider auto-restores from a previous save), e.g.
  // "Total Employees: 32" in the header while only 31 rows show. Base the
  // summary on the same filtered set the table itself shows (pre status-card
  // click, since that's this filter's own source, not something it should
  // also collapse against).
  const filteredShiftList = useMemo(
    () => filteredRosterRows.map((row) => row.__source),
    [filteredRosterRows],
  );

  const rosterSummary = useMemo(() => {
    const employees = filteredShiftList || [];
    const totalEmployees = employees.length;

    let assigned = 0;
    let weeklyOff = 0;
    let onLeave = 0;
    let unassigned = 0;
    let notJoined = 0;

    employees.forEach((employee) => {
      const flags = statusForEmployee(employee);
      assigned +=
        dataVisualMethod === "Daily"
          ? flags.hasAssigned
            ? 1
            : 0
          : flags.assignedDayCount;
      weeklyOff += flags.weekOffDayCount;
      if (flags.hasLeave) onLeave += 1;
      if (flags.hasUnassigned && !flags.hasAssigned) unassigned += 1;
      // Wasn't surfaced anywhere -- folded silently into `unassigned` above
      // with no way to see how many of those were "not yet joined" days vs.
      // genuinely unassigned ones.
      if (flags.hasNotJoined) notJoined += 1;
    });

    return {
      totalEmployees,
      assigned,
      weeklyOff,
      onLeave,
      unassigned,
      notJoined,
      openRequests: 0,
    };
  }, [filteredShiftList, dataVisualMethod, statusForEmployee]);

  const reportMetadata = useMemo(
    () => ({
      View: dataVisualMethod,
      Department: departmentNames || "All",
      Period: normalizedPeriodLabel || "-",
      "Total Employees": rosterSummary.totalEmployees,
      "Assigned to Shifts": rosterSummary.assigned,
      "Weekly Off": rosterSummary.weeklyOff,
      "On Leave": rosterSummary.onLeave,
      Unassigned: rosterSummary.unassigned,
      "Not Joined": rosterSummary.notJoined,
      "Open Shift Requests": rosterSummary.openRequests,
      "Report Generated On": moment().format("DD MMM YYYY, hh:mm A"),
    }),
    [dataVisualMethod, departmentNames, normalizedPeriodLabel, rosterSummary],
  );

  const handleRosterDownload = useCallback(
    async (rows, onProgress, downloadFormat = "excel") => {
      const fileName = `${dataVisualMethod} Shift Report`;
      const rowsToExport = (rows || []).map((row, index) =>
        row?.__source
          ? buildRosterExportRow(row.__source, index)
          : buildRosterExportRow(row, index),
      );

      if (downloadFormat === "csv") {
        await downloadCsv(
          rowsToExport,
          rosterFilterHeaders,
          fileName,
          {},
          reportMetadata,
          [],
          onProgress,
        );
        return;
      }

      if (downloadFormat === "pdf") {
        await downloadPdf(
          rowsToExport,
          rosterFilterHeaders,
          fileName,
          {},
          reportMetadata,
          [],
          onProgress,
        );
        return;
      }

      await downloadExcel(
        rowsToExport,
        rosterFilterHeaders,
        fileName,
        {},
        reportMetadata,
        [],
        onProgress,
      );
    },
    [
      dataVisualMethod,
      buildRosterExportRow,
      downloadCsv,
      downloadExcel,
      downloadPdf,
      reportMetadata,
      rosterFilterHeaders,
    ],
  );

  const compactFilterButtonSx = {
    ...designShell.compactOutlineButton,
    width: "100%",
    minHeight: 40,
    height: 40,
    justifyContent: "space-between",
    gap: 1,
    px: 2,
    py: 1,
    borderRadius: 1.5,
    backgroundColor: designColors.slate100,
    border: "none",
    boxShadow: "none",
    color: designColors.slate800,
    "&:hover": {
      backgroundColor: designColors.slate100,
      border: "none",
      boxShadow: "none",
    },
  };

  const renderDateHeaderFilter = () => {
    const inputType =
      dataVisualMethod === "Daily"
        ? "date"
        : dataVisualMethod === "Weekly"
          ? "week"
          : "month";
    const inputValue =
      dataVisualMethod === "Daily"
        ? dayjs(selectCurrentDate).format("YYYY-MM-DD")
        : dataVisualMethod === "Weekly"
          ? selectedWeek
          : moment(monthlyselectedDate).format("YYYY-MM");
    const staticLabel =
      dataVisualMethod === "Daily"
        ? "Date"
        : dataVisualMethod === "Weekly"
          ? "Week"
          : "Month";
    const displayValue =
      dataVisualMethod === "Daily"
        ? dayjs(selectCurrentDate).format("DD MMM YYYY")
        : dataVisualMethod === "Weekly"
          ? `${moment(selectedWeek).startOf("isoWeek").format("DD MMM")} - ${moment(
              selectedWeek,
            )
              .endOf("isoWeek")
              .format("DD MMM YYYY")}`
          : moment(monthlyselectedDate).format("MMMM YYYY");
    const maxValue =
      dataVisualMethod === "Daily"
        ? moment().format("YYYY-MM-DD")
        : dataVisualMethod === "Monthly"
          ? moment().format("YYYY-MM")
          : undefined;
    const minValue = dataVisualMethod === "Monthly" ? "2020-01" : undefined;

    return (
      <Mui.ButtonBase
        onClick={(event) => {
          const input = event.currentTarget.querySelector("input");
          if (input?.showPicker) {
            input.showPicker();
          } else {
            input?.focus();
            input?.click();
          }
        }}
        sx={compactFilterButtonSx}
      >
        <Mui.Stack
          direction="row"
          spacing={1.1}
          alignItems="center"
          sx={{ minWidth: 0, flex: 1 }}
        >
          <CalendarMonthOutlinedIcon
            sx={{ fontSize: 18, color: designColors.slate700, flexShrink: 0 }}
          />
          <Mui.Typography
            sx={{
              minWidth: 0,
              fontSize: 13.5,
              fontWeight: 600,
              color: designColors.slate800,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textAlign: "left",
            }}
          >
            {staticLabel} - {displayValue}
          </Mui.Typography>
        </Mui.Stack>
        <KeyboardArrowDownIcon
          sx={{ fontSize: 18, color: designColors.slate700, flexShrink: 0 }}
        />
        <input
          type={inputType}
          value={inputValue}
          max={maxValue}
          min={minValue}
          onChange={(event) => {
            if (!event.target.value) return;
            if (dataVisualMethod === "Daily") {
              handleDailyDateChange(event.target.value);
              return;
            }
            if (dataVisualMethod === "Weekly") {
              handleWeeklyDateOnChange({
                target: { value: event.target.value },
              });
              return;
            }
            handleMonthValueChange(event.target.value);
          }}
          style={{
            position: "absolute",
            inset: 0,
            opacity: 0,
            cursor: "pointer",
          }}
        />
      </Mui.ButtonBase>
    );
  };

  // return departmentNames === "All" ? (
  //   <Loader info="Loading..." />
  // ) : (
  return (
    <ThemeProvider theme={designTheme}>
      <Mui.Box
        sx={{
          ...designShell.pageSurface,
          px: { xs: 1.5, md: 2 },
          py: { xs: 2, md: 2.5 },
          // Safety net: no stray wide child may make the phone page scroll
          // sideways. "clip" (unlike "hidden") keeps sticky headers working.
          overflowX: { xs: "clip", md: "visible" },
        }}
      >
        <Mui.Stack spacing={2.25}>
          <Mui.Stack spacing={0.5}>
            {showShiftBack ? (
              <Mui.Box>
                <BackArrow
                  actionFunction={() => {
                    history.push("/admin/shift");
                    dispatch(setShowShiftBack(false));
                  }}
                />
              </Mui.Box>
            ) : null}
            <GlobalBreadcrumb
              trail={[
                {
                  label: "Team Workspace",
                  onClick: () => history.push("/admin/teamzone/home"),
                },
                "Roster",
              ]}
            />
          </Mui.Stack>

          <Mui.Stack
            direction={{ xs: "column", lg: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", lg: "center" }}
            spacing={2}
          >
            <Mui.Stack direction="row" spacing={1.5} alignItems="center">
              <Mui.Box
                sx={{
                  width: 52,
                  height: 52,
                  borderRadius: 2.5,
                  backgroundColor: designColors.tealTint,
                  color: designColors.tealDark,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <CalendarMonthOutlinedIcon sx={{ fontSize: 30 }} />
              </Mui.Box>
              <Mui.Box>
                <Mui.Typography sx={designType.pageTitle}>
                  Roster
                </Mui.Typography>
                <Mui.Typography sx={designType.pageSubtitle}>
                  View and manage team shifts for daily, weekly and monthly
                  schedules.
                </Mui.Typography>
              </Mui.Box>
            </Mui.Stack>

            <Mui.Box
              sx={{
                width: { xs: "100%", lg: "auto" },
                maxWidth: { xs: "100%", lg: "none" },
                flexShrink: 0,
              }}
            >
              <Mui.Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignItems: "center",
                  justifyContent: { xs: "stretch", lg: "flex-end" },
                  flexWrap: { xs: "wrap", lg: "nowrap" },
                }}
              >
                <Mui.Box
                  sx={{
                    flex: {
                      xs: "1 1 100%",
                      sm: "1 1 calc(50% - 8px)",
                      lg: "0 0 250px",
                    },
                    minWidth: 0,
                  }}
                >
                  <CompactHeaderSelectFilter
                    dataList={departmentData}
                    selectedValue={departmentNames}
                    updateDataFunction={updateDepartmentName}
                    Icons={PersonOutlineIcon}
                    staticLabel="Department"
                    widthSx={{ width: "100%" }}
                  />
                </Mui.Box>

                <Mui.Box
                  sx={{
                    flex: {
                      xs: "1 1 100%",
                      sm: "1 1 calc(50% - 8px)",
                      lg: "0 0 290px",
                    },
                    minWidth: 0,
                  }}
                >
                  {renderDateHeaderFilter()}
                </Mui.Box>
              </Mui.Box>
            </Mui.Box>
          </Mui.Stack>

          <Mui.Box
            sx={{
              display: "grid",
              gap: 2,
              gridTemplateColumns: {
                xs: "repeat(2, minmax(0, 1fr))",
                sm: "repeat(3, minmax(0, 1fr))",
                xl: "repeat(5, minmax(0, 1fr))",
              },
              "@media (max-width:599.95px)": {
                "& > :last-child:nth-child(odd)": { gridColumn: "1 / -1" },
              },
            }}
          >
            {[
              {
                key: "total-employees",
                title: "Total Employees",
                value: rosterSummary.totalEmployees,
                icon: Groups2RoundedIcon,
                accent: designColors.tealDark,
                tint: designColors.tealTint,
                filterKey: "",
              },
              {
                key: "assigned-to-shifts",
                title: "Assigned to Shifts",
                value: rosterSummary.assigned,
                icon: PersonAddAltRoundedIcon,
                accent: "#2F76E5",
                tint: "#EEF4FF",
                filterKey: "assigned",
              },
              {
                key: "weekly-off",
                title: "Weekly Off",
                value: rosterSummary.weeklyOff,
                icon: EventBusyRoundedIcon,
                accent: "#8B46E8",
                tint: "#F4F1FF",
                filterKey: "weeklyOff",
              },
              {
                key: "unassigned",
                title: "Unassigned",
                value: rosterSummary.unassigned,
                icon: AssignmentTurnedInRoundedIcon,
                accent: designColors.slate700,
                tint: designColors.slate100,
                filterKey: "unassigned",
              },
              {
                key: "not-joined",
                title: "Not Joined",
                value: rosterSummary.notJoined,
                icon: PersonOutlineIcon,
                accent: "#B45309",
                tint: "#FEF3C7",
                filterKey: "notJoined",
              },
            ].map((card) => (
              <StatCard
                key={card.key}
                icon={card.icon}
                title={card.title}
                value={card.value}
                accent={card.accent}
                tint={card.tint}
                isActive={
                  card.filterKey !== null &&
                  rosterStatusFilter === card.filterKey
                }
                onClick={
                  card.filterKey !== null
                    ? () => handleRosterStatusCardClick(card.filterKey)
                    : undefined
                }
              />
            ))}
          </Mui.Box>

          <FilterProvider
            userDetails={userDetails}
            domain={domain}
            subModuleId={planShiftSubModuleId}
          >
            <Mui.Box sx={{ ...designShell.sectionCard, overflow: "visible" }}>
              <Mui.Box
                sx={{
                  px: 2,
                  pt: 1.5,
                  pb: 1.25,
                  "& > div": {
                    py: 0,
                  },
                  "& .MuiTabs-root": {
                    mb: 1,
                  },
                }}
              >
                <CustomFilter
                  title="Roster List"
                  titleOverride={
                    <Mui.Tabs
                      value={dataVisualMethod}
                      onChange={(event, value) => switchView(value)}
                      textColor="inherit"
                      indicatorColor="primary"
                      sx={{
                        minHeight: 0,
                        flexShrink: 0,
                        "& .MuiTab-root": {
                          minHeight: 40,
                          textTransform: "none",
                          fontWeight: 700,
                          color: designColors.slate600,
                        },
                        "& .Mui-selected": {
                          color: designColors.tealDark,
                        },
                        "& .MuiTabs-indicator": {
                          backgroundColor: designColors.tealDark,
                          height: 3,
                          borderRadius: designRadii.pill,
                        },
                      }}
                    >
                      {buttons.map((button) => (
                        <Mui.Tab
                          key={button.value}
                          label={button.label}
                          value={button.value}
                        />
                      ))}
                    </Mui.Tabs>
                  }
                  filterHeaders={rosterFilterHeaders}
                  sortableHeaders={rosterSortHeaders}
                  data={filterInputRows}
                  filteredData={visibleRosterRows}
                  onFilteredDataChange={handleFilteredRosterChange}
                  customDownloadHandler={handleRosterDownload}
                  screenAccess={canManageShift}
                  showSaveButton={true}
                  hideCount={true}
                  labeledToolbar={true}
                  hideToolbarDivider={true}
                  downloadFormats={["excel", "pdf", "csv"]}
                  includeMetadata={true}
                  metadata={reportMetadata}
                  searchPlaceholder="Search by employee, department or shift..."
                />
              </Mui.Box>

              <Mui.Box sx={{ px: 1, pb: 1.25 }}>{renderComponent()}</Mui.Box>
            </Mui.Box>
          </FilterProvider>
        </Mui.Stack>
      </Mui.Box>
    </ThemeProvider>
  );
};
